import React, { useEffect } from 'react';

import './politicaPrivacidade.css';

export default function PoliticaPrivacidade() {
  useEffect(() => {
    const tituloAnterior = document.title;
    document.title = 'Política de Privacidade | eloOficina';
    window.scrollTo(0, 0);

    return () => { document.title = tituloAnterior; };
  }, []);

  return (
    <div className="privacy-page">
      <header className="privacy-header">
        <a href="https://eloadmin.com.br" aria-label="Ir para o site EloAdmin">
          <img src="/logo.png" alt="Elo Sistemas" className="privacy-logo" />
        </a>
        <div>
          <span className="privacy-app-name">eloOficina</span>
          <h1>Política de Privacidade</h1>
          <p>Última atualização: 9 de setembro de 2026</p>
        </div>
      </header>

      <main className="privacy-content">
        <section className="privacy-summary">
          <strong>Privacidade e transparência</strong>
          <p>
            Esta Política descreve como o aplicativo eloOficina trata as informações
            necessárias para registrar e enviar inspeções veiculares com fotografias.
          </p>
        </section>

        <section>
          <h2>1. Identificação do responsável</h2>
          <p>
            O aplicativo <strong>eloOficina</strong>, identificado pelo pacote
            {' '}<strong>br.com.eloadmin</strong>, é disponibilizado por
            {' '}<strong>José Ricardo Souza Campos</strong>, doravante denominado “Responsável”.
          </p>
        </section>

        <section>
          <h2>2. Sobre o aplicativo</h2>
          <p>
            O eloOficina é destinado ao registro de inspeções veiculares. Usuários
            autorizados podem identificar um veículo, registrar informações da inspeção,
            tirar fotografias e enviar os dados ao sistema da organização responsável. O
            aplicativo é destinado ao uso profissional por oficinas, empresas e seus usuários autorizados.
          </p>
        </section>

        <section>
          <h2>3. Dados tratados</h2>
          <p>Dependendo da utilização do aplicativo, poderão ser tratados:</p>
          <ul>
            <li>dados de identificação e autenticação do usuário, como código, nome e e-mail;</li>
            <li>identificação interna da inspeção e placa do veículo;</li>
            <li>fotografias do veículo e de eventuais avarias;</li>
            <li>data e horário da criação, do recebimento e do envio da inspeção;</li>
            <li>registros técnicos necessários à segurança, ao diagnóstico de erros e ao funcionamento do serviço;</li>
            <li>outros dados inseridos voluntariamente durante a inspeção.</li>
          </ul>
          <p>
            Fotografias podem registrar acidentalmente pessoas, documentos, endereços ou
            outros elementos presentes no ambiente. O usuário deve evitar fotografar
            informações que não sejam necessárias para a inspeção. Os dados não são usados
            para publicidade comportamental.
          </p>
        </section>

        <section>
          <h2>4. Permissões utilizadas</h2>
          <h3>Câmera</h3>
          <p>
            A câmera é usada exclusivamente mediante ação do usuário para fotografar o
            veículo e registrar eventuais avarias relacionadas à inspeção.
          </p>
          <h3>Armazenamento do dispositivo</h3>
          <p>
            As fotografias podem permanecer temporariamente no dispositivo enquanto a
            inspeção estiver sendo preparada ou aguardando envio. Após a confirmação do
            envio pelo servidor, o aplicativo exclui as cópias locais. Se o envio falhar,
            elas poderão permanecer no dispositivo para uma nova tentativa.
          </p>
          <h3>Internet</h3>
          <p>
            O acesso à internet é utilizado para autenticação, consulta de informações e
            envio dos dados e fotografias da inspeção ao servidor.
          </p>
        </section>

        <section>
          <h2>5. Finalidades do tratamento</h2>
          <p>Os dados são utilizados para:</p>
          <ul>
            <li>identificar e autenticar usuários autorizados;</li>
            <li>registrar e acompanhar inspeções veiculares;</li>
            <li>relacionar fotografias ao veículo e à inspeção correspondente;</li>
            <li>enviar e armazenar informações no sistema da organização responsável;</li>
            <li>permitir controle, auditoria e consulta ao histórico das inspeções;</li>
            <li>prevenir acessos indevidos, fraudes e incidentes de segurança;</li>
            <li>diagnosticar erros, melhorar o aplicativo e cumprir obrigações legais.</li>
          </ul>
        </section>

        <section>
          <h2>6. Bases legais</h2>
          <p>
            O tratamento poderá ter como fundamento as bases legais previstas na Lei nº
            13.709/2018 — Lei Geral de Proteção de Dados Pessoais (LGPD), especialmente a
            execução de contrato, o cumprimento de obrigação legal ou regulatória, o
            exercício regular de direitos, o legítimo interesse e, quando aplicável, o
            consentimento do titular.
          </p>
        </section>

        <section>
          <h2>7. Compartilhamento de dados</h2>
          <p>Os dados poderão ser compartilhados, quando necessário, com:</p>
          <ul>
            <li>a empresa, oficina ou organização responsável pela inspeção;</li>
            <li>fornecedores de hospedagem, armazenamento, infraestrutura e suporte técnico;</li>
            <li>prestadores contratados para manutenção e segurança dos sistemas;</li>
            <li>autoridades públicas, mediante obrigação legal, ordem judicial ou requisição válida;</li>
            <li>terceiros envolvidos na proteção de direitos ou investigação de fraudes e incidentes.</li>
          </ul>
          <p>
            Os prestadores recebem somente as informações necessárias para suas atividades
            e devem observar deveres de segurança e confidencialidade. O Responsável não
            vende dados pessoais nem compartilha fotografias para fins publicitários.
          </p>
        </section>

        <section>
          <h2>8. Armazenamento e retenção</h2>
          <p>
            As informações enviadas ao servidor são mantidas pelo período necessário para
            executar as finalidades desta Política, atender contratos, conservar o histórico
            das inspeções, cumprir obrigações legais e exercer direitos. Quando deixarem de
            ser necessárias, serão eliminadas ou anonimizadas, salvo quando a conservação
            for permitida ou exigida por lei.
          </p>
          <p>
            As fotografias temporárias armazenadas no celular são excluídas após a
            confirmação do envio. Em caso de falha, poderão permanecer até uma nova
            tentativa, exclusão manual ou limpeza dos dados do aplicativo.
          </p>
        </section>

        <section>
          <h2>9. Segurança das informações</h2>
          <p>
            São adotadas medidas administrativas e técnicas destinadas a proteger os dados
            contra acesso não autorizado, perda, alteração, divulgação ou destruição
            indevida, incluindo autenticação, restrição de permissões e controles de acesso.
            Apesar dessas medidas, nenhum sistema é completamente imune a incidentes.
          </p>
        </section>

        <section>
          <h2>10. Responsabilidade do usuário</h2>
          <p>O usuário deve:</p>
          <ul>
            <li>manter suas credenciais de acesso em sigilo e não permitir o uso da conta por terceiros;</li>
            <li>fotografar somente informações necessárias à inspeção;</li>
            <li>evitar registrar pessoas, documentos ou dados pessoais sem necessidade;</li>
            <li>comunicar suspeitas de acesso indevido;</li>
            <li>seguir as orientações da organização responsável.</li>
          </ul>
        </section>

        <section>
          <h2>11. Direitos do titular</h2>
          <p>Nos termos da LGPD, o titular poderá solicitar, quando aplicável:</p>
          <ul>
            <li>confirmação da existência de tratamento e acesso aos dados;</li>
            <li>correção de dados incompletos, inexatos ou desatualizados;</li>
            <li>anonimização, bloqueio ou eliminação de dados desnecessários ou irregulares;</li>
            <li>portabilidade, observadas as normas aplicáveis;</li>
            <li>informações sobre o compartilhamento dos dados;</li>
            <li>revogação do consentimento e eliminação dos dados tratados com essa base legal;</li>
            <li>oposição a tratamento realizado em desconformidade com a LGPD;</li>
            <li>revisão de decisões exclusivamente automatizadas, quando aplicável.</li>
          </ul>
        </section>

        <section>
          <h2>12. Solicitação de exclusão</h2>
          <p>
            Para solicitar acesso, correção ou exclusão da conta e dos dados relacionados ao
            eloOficina, envie uma mensagem para
            {' '}<a href="mailto:elo.suporte@hotmail.com">elo.suporte@hotmail.com</a>. A
            solicitação deverá conter informações suficientes para confirmar a identidade
            do solicitante e localizar os dados correspondentes.
          </p>
          <p>
            Algumas informações poderão ser conservadas para cumprimento de obrigação
            legal, exercício regular de direitos, prevenção a fraudes ou outras hipóteses
            permitidas pela LGPD. Quando os acessos forem administrados pela empresa
            contratante, a solicitação também poderá ser encaminhada ao administrador da conta.
          </p>
        </section>

        <section>
          <h2>13. Crianças e adolescentes</h2>
          <p>
            O eloOficina é destinado ao uso profissional e não é direcionado a crianças ou
            adolescentes. Não coletamos intencionalmente dados de crianças por meio do aplicativo.
          </p>
        </section>

        <section>
          <h2>14. Transferência internacional</h2>
          <p>
            Fornecedores de infraestrutura ou hospedagem poderão processar informações em
            outros países. Quando isso ocorrer, serão adotadas medidas apropriadas para a
            proteção dos dados conforme a LGPD.
          </p>
        </section>

        <section>
          <h2>15. Alterações nesta Política</h2>
          <p>
            Esta Política poderá ser atualizada para refletir mudanças no aplicativo, nos
            serviços ou na legislação. A versão mais recente permanecerá disponível nesta página.
          </p>
        </section>

        <section className="privacy-contact">
          <h2>16. Contato</h2>
          <dl>
            <div><dt>Aplicativo</dt><dd>eloOficina</dd></div>
            <div><dt>Identificador</dt><dd>br.com.eloadmin</dd></div>
            <div><dt>Responsável</dt><dd>José Ricardo Souza Campos</dd></div>
            <div><dt>Site</dt><dd><a href="https://eloadmin.com.br">eloadmin.com.br</a></dd></div>
            <div><dt>E-mail</dt><dd><a href="mailto:elo.suporte@hotmail.com">elo.suporte@hotmail.com</a></dd></div>
          </dl>
        </section>
      </main>

      <footer className="privacy-footer">
        <span>© 2026 eloOficina</span>
        <a href="https://eloadmin.com.br">Voltar ao site</a>
      </footer>
    </div>
  );
}
